import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserController } from '@domain';

/**
 * Libera a rota para admin/owner DA EMPRESA CORRENTE (`companyAccess.role`) OU para
 * o admin interno (staff) do RapiDocs (`user.profile`, perfil GLOBAL). Usado na
 * Auditoria: o cliente (admin/owner) vê a auditoria da própria empresa; o staff
 * RapiDocs inspeciona qualquer empresa via seletor do menu-top.
 */
@Injectable({
    providedIn: 'root',
})
export class AdminOrRapidocsGuard implements CanActivate {
    private _router = inject(Router);
    private _userController = inject(UserController);

    public canActivate(): boolean {
        // Hidrata o usuário (signal/cookie) antes de checar — cobre reload direto na rota.
        this._userController.getCurrentUser();

        if (this._userController.isAdminOrOwner() || this._userController.isRapidocsAdmin()) {
            return true;
        }

        this._router.navigate(['/platform']);
        return false;
    }
}
